export * from './keyboardShortcuts';

export const NEXT_CELL_DELIMITER = '\t';
export const NEWLINE_DELIMITER = '\n';
export const PLACEHOLDER_NEWLINE = '<NEWLINE>';

export const PASTE_DEPTH_INDICATOR = '\u2003';

export const NUMBER_OF_BOM_LINES = 51;

export const MAX_NUMBER_OF_UNIQUE_BOM_PARTS_WARNING = 900;
export const MAX_NUMBER_OF_UNIQUE_BOM_PARTS = 1000;

export const MAX_NUMBER_OF_UNIQUE_BOM_PARTS_REACHED_MESSAGE =
  "BOM can't contain more than 1,000 unique parts";

export const ID_COLUMN_WIDTH = 118;
export const PART_NUMBER_COMULN_WIDTH = 348;

export const CELL_HEIGHT_UNIT = 4;

export const INERT_CELL_OUTLINE_STYLES = {
  outlineWidth: 2,
  outlineOffset: -2,
  outlineStyle: 'solid',
  outlineColor: 'var(--cell-background)',
  borderRadius: 'sm',
} as const;

export const CELL_OUTLINE_STYLES = {
  ...INERT_CELL_OUTLINE_STYLES,
  outlineColor: 'interaction.main',
} as const;

export const CELL_FOCUS_VISIBLE_STYLES = { outline: 'none' } as const;

export const NUMERIC_KEY_CODES = [
  'Digit0',
  'Digit1',
  'Digit2',
  'Digit3',
  'Digit4',
  'Digit5',
  'Digit6',
  'Digit7',
  'Digit8',
  'Digit9',
  'Numpad0',
  'Numpad1',
  'Numpad2',
  'Numpad3',
  'Numpad4',
  'Numpad5',
  'Numpad6',
  'Numpad7',
  'Numpad8',
  'Numpad9',
];

export const PRINTABLE_KEY_CODES = [
  'KeyA',
  'KeyB',
  'KeyC',
  'KeyD',
  'KeyE',
  'KeyF',
  'KeyG',
  'KeyH',
  'KeyI',
  'KeyJ',
  'KeyK',
  'KeyL',
  'KeyM',
  'KeyN',
  'KeyO',
  'KeyP',
  'KeyQ',
  'KeyR',
  'KeyS',
  'KeyT',
  'KeyU',
  'KeyV',
  'KeyW',
  'KeyX',
  'KeyY',
  'KeyZ',
  'NumpadDecimal',
  'NumpadAdd',
  'NumpadSubtract',
  'NumpadMultiply',
  'NumpadDivide',
  'Space',
  'Minus',
  'Equal',
  'BracketLeft',
  'BracketRight',
  'Backslash',
  'Semicolon',
  'Quote',
  'Comma',
  'Period',
  'Slash',
  'Backquote',
  'IntlBackslash',
  'IntlRo',
  'IntlYen',
  ...NUMERIC_KEY_CODES,
];
